var start;
const gamepadButtons = [
  'a',
  'x',
  'b',
  'y',
  'sl',
  'sr',
  '-',
  '-',
  'minus',
  'plus',
  'lstick',
  'rstick',
  'home',
  'screenshot',
  'bumper',
  'trigger',
];

const RIGHT = 1,
  LEFT = -1;

const joystickMap = {
  '-0.4285714285714286': [0, -1],
  '-0.1428571428571429': [1, -1],
  '0.1428571428571428': [1, 0],
  '0.4285714285714286': [1, 1],
  '0.7142857142857142': [0, 1],
  '1': [-1, 1],
  '-1': [-1, 0],
  '-0.7142857142857143': [-1, -1],
  '1.2857142857142856': [0, 0],
};

const stable = [0, 0];

let left = 0,
  top = 0,
  offset = stable;

const getJoystickNav = num =>
  joystickMap.hasOwnProperty(num) ? joystickMap[num] : stable;

const buttonPressed = key => {
  if (typeof key == 'object') {
    return key.pressed;
  }
  return false;
};

const gameLoop = options => () => {
  var gamepads = navigator.getGamepads
    ? navigator.getGamepads()
    : navigator.webkitGetGamepads
    ? navigator.webkitGetGamepads
    : [];
  if (!gamepads) {
    return;
  }

  var gp = gamepads[0];
  gamepadButtons.map((button, index) => {
    if (buttonPressed(gp.buttons[index])) {
      typeof options[button] === 'function' && options[button]();
    }
  });

  offset = getJoystickNav(gp.axes[0]);
  left += offset[0];
  top += offset[1];
  options.pointerRef.current.style.opacity = buttonPressed(
    options.pointerRef.current.hand === RIGHT ? gp.buttons[11] : gp.buttons[10]
  )
    ? 0.9
    : 0.2;
  options.pointerRef.current.style.bottom = `calc(1rem - ${
    options.pointerRef.current.hand
  } * ${top} * 10px)`;
  options.pointerRef.current.style.right = `calc(1rem - ${
    options.pointerRef.current.hand
  } * ${left} * 10px)`;

  start = requestAnimationFrame(gameLoop(options));
};

export const gamepadConnect = options => evt => {
  options.pointerRef.current.hand = evt.gamepad.id.match('(R)') ? RIGHT : LEFT;
  options.displayRef.current.innerHTML = `Gamepad connected at index ${
    evt.gamepad.index
  }: ${evt.gamepad.id}. ${evt.gamepad.buttons.length} buttons, ${
    evt.gamepad.axes.length
  } axes.`;
  console.log(
    'Gamepad connected at index %d: %s. %d buttons, %d axes.',
    evt.gamepad.index,
    evt.gamepad.id,
    evt.gamepad.buttons.length,
    evt.gamepad.axes.length
  );
  gameLoop(options)();
};

export const gamepadDisconnect = () => {
  cancelAnimationFrame(start);
  console.log('Gamepad disconnected.');
};
